function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/builtin/nonIterableSpread.js
// module id = 363
// module chunks = 0